import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fr8bot-ui-page-filters-info',
  templateUrl: './page-filters-info.component.html',
  host: { class: 'tw:typography-body-2 tw:flex tw:min-h-6 tw:items-center tw:text-gray-3' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFiltersInfoUIComponent {}
